module.exports = __webpack_public_path__ + "img/Group 705.54b99965.png";